import { useState } from 'react';
import { useAuth } from './AuthContext.tsx';
import { Modal } from './Modal.tsx';

export function SetPasswordModal() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { setPassword: updatePassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    try {
      await updatePassword(password);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={() => {}}
      title="Set Your Password"
      width="max-w-md w-full"
      className="bg-[#2a2a2a]"
      contentClassName="!p-8"
      overlayClassName="bg-black/90"
      closeOnOverlayClick={false}
      hideCloseButton={true}
    >
      <p className="text-[#888] mb-6">Please set a password for your account to continue.</p>

      {error && <div className="bg-red-500 text-white p-3 rounded mb-4">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="w-full px-4 py-2 bg-[#333] border border-[#444] rounded text-white"
            required
          />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            className="w-full px-4 py-2 bg-[#333] border border-[#444] rounded text-white"
            required
          />
        <button type="submit" className="w-full px-4 py-2 bg-gradient-to-br from-[#667eea] to-[#764ba2] text-white rounded font-semibold hover:opacity-90">
          Set Password
        </button>
      </form>
    </Modal>
  );
}

